import store from '@/store'


export function formatNumberWithComma(value) {
  if(!value) return '0';
  let numToStr = value;
  if(typeof value === 'number') numToStr = String(value);
  const [intPart, decimalPart] = numToStr.toString().split(".");
  const withComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimalPart ? `${withComma}.${decimalPart}` : withComma;
}

// 내림 처리 함수
export function formatDecimal(value, precision) {
  const factor = 10 ** precision;
  const temp = Math.floor((Number(value) + Number.EPSILON) * factor);
  const result = (temp / factor).toFixed(precision);
  return result;
}
export function amountFormatter(value, symbol, onlySymbol) {
  const type = store.state.transact.sizeType
  const allSymbol = store.state.transact.allSymbolData
  const isBitget = store.state.transact.isBitget
  let pricePrecision, quantityPrecision;
  const symbolData = allSymbol.find((s) => s.symbol === `${symbol}USDT`);
  if (!symbolData) return '--';

  if (isBitget) {
    pricePrecision = Number(symbolData.pricePlace);
    quantityPrecision = Number(symbolData.volumePlace);
  } else {
    pricePrecision = symbolData.pricePrecision;
    quantityPrecision = symbolData.quantityPrecision;
  }
  if( onlySymbol ){
    return `${formatDecimal(value, quantityPrecision)}`;
  }
  if (type === "USDT") {
    return `${formatDecimal(value, pricePrecision)} USDT`;
  } else {
    return `${formatDecimal(value, quantityPrecision)} ${symbol}`;
  }
}
//주문시 코인별 최소수량, 최소금액 충족체크
export function isOrderValid(symbolData, orderQty, orderUsdt, orderType) {
  const data = symbolData;
  if (!data) return false;
  const minQty =
    orderType === "limit"
      ? parseFloat(data.limitMinQty)
      : parseFloat(data.marketMinQty);
  const minNotional = parseFloat(data.minNotional);
  const userQty = parseFloat(orderQty);
  const userUsdt = parseFloat(orderUsdt);
  // console.log('userQty',userQty);
  // console.log('userUsdt',userUsdt);
  // console.log('minNotional',minNotional);
  // console.log('minQty',minQty);
  let isQtyValid, isNotionalValid;
  if (orderQty) {
    isQtyValid = userQty >= minQty;
  } else if (orderUsdt) {
    isNotionalValid = userUsdt >= minNotional;
  }

  return isQtyValid || isNotionalValid;
}

//주문시 tpsl 금액 유효성 체크
export function isTpslValid(value, symbolData, tpslType, orderPrice, side) {
  const minPrice = parseFloat(symbolData.minPrice);
  const maxPrice = parseFloat(symbolData.maxPrice);
  const price = parseFloat(value);

  if (isNaN(price)) return false;

  const isTp = tpslType === 'tp';
  const isSl = tpslType === 'sl';
  const isBuy = side === 'buy';
  const isSell = side === 'sell';

  if (
    (isTp && isBuy && (price <= orderPrice || price > maxPrice)) ||
    (isTp && isSell && (price >= orderPrice || price < minPrice)) ||
    (isSl && isSell && (price <= orderPrice || price > maxPrice)) ||
    (isSl && isBuy && (price >= orderPrice || price < minPrice))
  ) {
    return false;
  }

  return true;
}

export function inputNumCheck(v, precision) {
  let value = v.replace(/[^0-9.]/g, "");
  
  if (value.startsWith(".")) {
    value = "0" + value;
  }
  const firstDotIndex = value.indexOf(".");
  if (firstDotIndex !== -1) {
    const beforeDot = value.slice(0, firstDotIndex + 1);
    const afterDot = value.slice(firstDotIndex + 1).replace(/\./g, "");
    value = beforeDot + afterDot;
  }
  const parts = value.split(".");
  if (parts.length === 2) {
    if (precision === 0) {
      value = parts[0];
    } else {
      parts[1] = parts[1].slice(0, precision);
      value = parts[0] + "." + parts[1];
    }
  }

  return value.toString();
}

export function inputBlurNumCheck(v, symbolData, type, orderPrice) {
  const minPrice = parseFloat(symbolData.minPrice);
  const maxPrice = parseFloat(symbolData.maxPrice);
  let price = parseFloat(v);
  if (type === "price") {
    if (price < minPrice) price = minPrice;
    if (price > maxPrice) price = maxPrice;
  }
  if (type === "tp") {
    if (price <= orderPrice ||  price > maxPrice) price = maxPrice;
  }
  if (type === "sl") {
    if (price >= orderPrice || price  < minPrice) price = minPrice;
  }
  if (isNaN(price)) {
    return null;
  }
  return price;
}


